// Разделы каталога. Список нужен и главной (ссылки в конце текста),
// и странице каталога — общий ключ делает из двух вызовов один запрос.
// Загрузчик объявлен один раз на модуль: Nuxt сверяет вызовы по ссылке
// на функцию и на двух разных стрелках ругается «different handler»
const loadCategories = () => $fetch("/api/categories");

export const useCategories = () => useAsyncData("categories", loadCategories);
